import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const JobProfileLeftWrapper = styled.div`
  display: flex;
  flex: 1;
  background-color: #fff;
  border-radius: 8px;
  margin: 10px;
  padding: 10px 20px;
  flex-direction: column;
  box-shadow: 0 0 15px #dcdcdc;

  ${mediaMaxWidth.smallDesktop`
    width: 455px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 20px);
  `}
`;

export const JobTitle = styled.div``;

export const Section = styled.div``;

export const SectionHeader = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;

  ${mediaMaxWidth.tablet`
    font-size: .85em;
  `}
`;

export const SectionHeaderText = styled.div``;

export const Tooltip = styled.div`
  padding: 0 5px;
  cursor: pointer;

  svg {
    font-size: 0.85em;
    color: rgb(187, 187, 187);
    transition: all 0.1s ease-in-out 0s;
  }
`;

export const Badge = styled.span`
  color: #666;
  margin-left: 5px;
  font-family: sans-serif;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  font-weight: bold;
  font-size: 0.4em;
  background-color: #fff;
  position: relative;
  border: 1px solid #666;
  text-transform: uppercase;
  top: -10px;
  padding: 2px 6px;
  border-radius: 20px;
  height: 15px;
`;

export const BadgeTooltip = styled.div`
  font-weight: 600;
`;

export const SectionContent = styled.div`
  font-size: ${(props) => (props.large ? "2em" : "1em")};
  padding: ${(props) => (props.large ? "0px 10px" : "5px 10px")};
  line-height: 1.6em;
  text-transform: ${(props) => (props.capitalize ? "capitalize" : null)};
  margin-bottom: 10px;

  ${mediaMaxWidth.phone`
    font-size: ${(props) => (props.large ? "1.5em" : "0.875em")};
  `}
`;

export const SubContent = styled.span`
  font-size: 0.7em;
  margin-left: 10px;
`;

export const MultiSection = styled.div`
  display: flex;
  flex-direction: row;

  ${mediaMaxWidth.phone`
    flex-direction: column;
  `}
`;

export const MutiSectionItem = styled.div`
  display: flex;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const BenefitsListWrapper = styled.ul`
  padding-left: 18px;
`;

export const BenefitsListItem = styled.li`
  margin: 5px 0;
`;

export const KeySkillsListWrapper = styled.ul`
  padding-left: 0;
`;

export const KeySkillsListItem = styled.li`
  margin: 5px 0;
  list-style: none;

  &:before {
    content: "\f00c";
    font-family: FontAwesome;
    color: #27ae60;
    display: inline-block;
    width: 25px;
  }
`;
